import { getQueryStringParams } from '~/core/helpers/url/get-query-params/get-query-params.helper';

export function parseStringifyUrl(url: string) {
  const decodedUrl = decodeURIComponent(url);
  const [baseUrl, stringifyQueryParams] = decodedUrl.split('?');

  return {
    baseUrl,
    queryParams: getQueryStringParams(stringifyQueryParams),
  };
}
